import { ForemanDB } from '../../types/IndexedDB/ForemanDB'
import { RequestBacklog } from '../../types/Work/Request'
import { showErrorToast } from '../CommonServices/alertServices'

export const mapRequests = async (
	db: ForemanDB,
	newRequests: RequestBacklog[],
	taskId: number,
	taskType: string,
) => {
	try {
		await db.transaction('rw', [db.requests], async () => {
			db.setHooksEnabled(false)
			if (taskType === 'workItemTask') {
				await db.requests.filter((r) => r.taskId === taskId && r.reworkId === null).delete()
			} else if (taskType === 'reworkTask') {
				await db.requests.filter((r) => r.reworkId === taskId).delete()
			}

			if (newRequests.length > 0) {
				await db.requests.bulkAdd(newRequests)
			}
			db.setHooksEnabled(true)
		})
	} catch (error) {
		showErrorToast({
			message: 'Error mapping requests',
		})
	}
}
